"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataReader = void 0;
class DataReader {
    constructor(data) {
        this._data = data;
    }
    async open() {
        return this._data.byteLength;
    }
    async close() {
        // no-op
    }
    async read(offset, length) {
        return new Uint8Array(this._data, offset, length);
    }
    size() {
        return this._data.byteLength;
    }
}
exports.DataReader = DataReader;
//# sourceMappingURL=DataReader.js.map